import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiImage, FiShare2, FiTwitter, FiMessageCircle, FiCheck } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const ActionBar = ({ onDownload, shareData }) => {
  const [showShare, setShowShare] = useState(false);
  const shareText = `My TDEE is ${shareData.tdee} kcal! Target for ${shareData.goalName}: ${shareData.goalCalories} kcal. Check yours at TDEE Lab.`;

  const handleTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, '_blank');
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
  };

  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-40">
      <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl border border-gray-200 dark:border-gray-700 rounded-2xl shadow-2xl p-2 flex items-center gap-1">
        <button 
          onClick={onDownload} 
          className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-xs font-black uppercase tracking-widest transition-all active:scale-95"
        >
          <SafeIcon icon={FiImage} />
          <span>Save Image</span>
        </button>
        
        <div className="h-6 w-px bg-gray-200 dark:bg-gray-700 mx-1" />
        
        <div className="relative">
          <button 
            onClick={() => setShowShare(!showShare)} 
            className={`p-2.5 rounded-xl transition-all ${showShare ? 'bg-gray-200 dark:bg-gray-700 text-blue-600' : 'text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700'}`}
          >
            <SafeIcon icon={FiShare2} className="w-5 h-5" />
          </button>
          
          <AnimatePresence>
            {showShare && (
              <motion.div 
                initial={{ opacity: 0, y: 10, scale: 0.95 }} 
                animate={{ opacity: 1, y: 0, scale: 1 }} 
                exit={{ opacity: 0, y: 10, scale: 0.95 }}
                className="absolute bottom-full mb-4 right-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-2xl p-3 flex flex-col gap-2 min-w-[160px]"
              >
                <button onClick={handleTwitter} className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-colors text-left">
                  <div className="w-8 h-8 rounded-lg bg-black flex items-center justify-center text-white">
                    <SafeIcon icon={FiTwitter} />
                  </div>
                  <span className="text-xs font-bold">Twitter</span>
                </button>
                <button onClick={handleWhatsApp} className="flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-xl transition-colors text-left">
                  <div className="w-8 h-8 rounded-lg bg-green-500 flex items-center justify-center text-white">
                    <SafeIcon icon={FiMessageCircle} />
                  </div>
                  <span className="text-xs font-bold">WhatsApp</span>
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default ActionBar;